import { render, staticRenderFns } from "./ChanageCpStatus.vue?vue&type=template&id=270032a4&scoped=true"
import script from "./ChanageCpStatus.vue?vue&type=script&lang=js"
export * from "./ChanageCpStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270032a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270032a4')) {
      api.createRecord('270032a4', component.options)
    } else {
      api.reload('270032a4', component.options)
    }
    module.hot.accept("./ChanageCpStatus.vue?vue&type=template&id=270032a4&scoped=true", function () {
      api.rerender('270032a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/sku/ChanageCpStatus.vue"
export default component.exports